import { createSelector } from "@ngrx/store"
import { from } from "rxjs";
import { MyPurchaseForm } from "../../shared/models/app-models"
import { DOTPReason, WOCReason } from "../../shared/models/app-models/MyPurchaseForm.model";

export interface WOC {
  WOCId: string | null;
  WoCReason: WOCReason;
  WOCFileReferenceNumber: string | null | undefined;
  WOCJustification: string | null | undefined
}

export const selectWOC = createSelector((state: any) => {
  return state.form as MyPurchaseForm
}, (form): WOC => ({
    WOCId: form.WOCId,
    WoCReason: form.WoCReason as WOCReason,
    WOCFileReferenceNumber: form.WOCFileReferenceNumber,
    WOCJustification: form.WOCJustification,
}))

export interface DOTP {
  DOTPId: string | null;
  DOTPReasonId: string | null;
  DoTPReason: DOTPReason;
  DOTPJustification: string | null | undefined;
  DOTPRemarks :string | null | undefined;
}

export const selectDOTP = createSelector((state: any) => {
  return state.form as MyPurchaseForm
}, (form): DOTP => ({
    DOTPId: form.DOTPId,
    DOTPReasonId : form.DOTPReasonId,
    DoTPReason: form.DoTPReason as DOTPReason,
    DOTPJustification: form.DOTPJustification,
    DOTPRemarks: form.DOTPRemarks
}))
